import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal, Slider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import InputArea from "../../../../common/components/FormFields/InputArea";
import InputField from "../../../../common/components/FormFields/InputField";
import RadioField from "../../../../common/components/FormFields/RadioField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { fetchDoctor } from "../../../../commonServices/miscellaneousServices/MiscServices";
// import PainAssessmentScale from "../../../../emergency/components/registration/opdTretmentRecord/assets/PainAssessmentScale.svg";
import PainAssessmentScale from "./PainAssessmentScale.svg";
import {
  addNewOrderSheet,
  fetchOrderSheetTaskDetails,
} from "../../../services/cliinicalChartServices/orderSheetServices/OrderSheetServices";
import ViewOrderSheet from "./ViewOrderSheet";

import { styled } from "@mui/material/styles";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import OtherDetails from "./OtherDetails";
import ToDoListComponent from "./ToDoListComponent";
import { format, parse } from "date-fns";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import {
  getNursingNoteDescription,
  NursesNotePrint,
} from "../../../services/cliinicalChartServices/nursingnoteServices/NursingNoteServices";

export const Style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  border: "none",
  "&:focus": {
    outline: "none",
  },
  // borderRadius: 2,
  width: "98%",
  minHeight: "70%",
  maxHeight: "95%",
};

const avpuArray = [
  { id: 0, value: "Alert", label: "Alert" },
  { id: 1, value: "Respond to Voice", label: "Respond to Voice" },
  { id: 2, value: "Pain", label: "Pain" },
  { id: 3, value: "Unresponsive", label: "Unresponsive" },
];

const isCPR = [
  { id: 0, value: "Yes", label: "Yes" },
  { id: 1, value: "NO", label: "No" },
];

const isRocs = [
  { id: 0, value: "Yes", label: "Yes" },
  { id: 1, value: "NO", label: "No" },
];

const schema = yup
  .object({
    dietPlan: yup.string().when("dietPlanCheck", {
      is: false,
      then: yup.string().required(),
    }),

    referanceDoctor: yup
      .array()
      .of(
        yup
          .object()
          .nullable()
          .shape({
            value: yup.string().required("Value is required"),
            label: yup.string().required("Label is required"),
          }),
      )
      .nullable()
      .when("referanceDoctorCheck", {
        is: (referanceDoctorCheck) => !referanceDoctorCheck,
        then: yup
          .array()
          .min(1, "At least one doctor must be selected")
          .required("Required"),
      }),
    painScoreInput: yup.number().min(0).max(10).required(),
  })
  .required();

//////pain score/assessment
function valueText(value) {
  return `${value}°C`;
}
const CustomSlider = styled(Slider)({
  color: "#52af77",
  height: 8,
  padding: 7,

  "& .MuiSlider-mark": {
    border: "none",
    color: "gray",
    height: 7,
  },
  "& .MuiSlider-rail": {
    border: "none",
    backgroundImage:
      "linear-gradient(.25turn,  lightblue, green, greenyellow, yellow, orange, red)",
  },
  "& .MuiSlider-track": {
    border: "none",
    backgroundImage:
      "linear-gradient(.25turn,  lightblue, green, greenyellow, yellow, orange, red)",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid blue",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "black",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});
const sliderMarks = [
  {
    value: 0,
    scaledValue: 0,
  },
  {
    value: 1,
    scaledValue: 1,
  },
  {
    value: 2,
    scaledValue: 2,
  },
  {
    value: 3,
    scaledValue: 3,
  },
  {
    value: 4,
    scaledValue: 4,
  },
  {
    value: 5,
    scaledValue: 5,
  },
  {
    value: 6,
    scaledValue: 6,
  },
  {
    value: 7,
    scaledValue: 7,
  },
  {
    value: 8,
    scaledValue: 8,
  },
  {
    value: 9,
    scaledValue: 9,
  },
  {
    value: 10,
    scaledValue: 10,
  },
];

export default function OrderSheetModal(props) {
  const getUserRole = JSON.parse(localStorage.getItem("userInfo")); //cashCounter==="C. M. O."

  let AllowInfo =
    getUserRole.cashCounter === "C. M. O." ||
    getUserRole?.userRoles?.some((item) => item === "Super Admin")
      ? true
      : false;

  const defaultValues = {
    subjective: "",
    temp: "",
    bp: "",
    pulse: "",
    rr: "",
    cvp: "",
    mews: "",
    spO2: "",
    peripheralpulse: "",
    cvs: "",
    rs: "",
    pa: "",
    pv: "",
    cns: "",
    localexamation: "",
    other: "",
    assessment: "",
    cprNotes: "",
    plan: "",
    avpu: null,
    referanceDoctor: null,
    //new
    dietPlan: "",
    dietPlanCheck: false,
    stoolYes: false,
    stoolNo: false,
    urineYes: false,
    urineNo: false,
    cprYes: false,
    cprNo: false,
    cprStartTime: null,
    cprEndTime: null,
    cycleOfCprGiven: "",
    roscYes: false,
    roscNo: false,
    painScoreInput: "",
  };

  const {
    control,
    handleSubmit,
    reset,
    watch,
    register,
    setValue,
    formState: { errors },
  } = useForm(allSchema());

  function allSchema() {
    return {
      mode: "onChange",
      resolver: AllowInfo && yupResolver(schema),
      defaultValues: defaultValues,
    };
  }
  let noReferDoct = watch("referanceDoctorCheck");
  let noDietPlan = watch("dietPlanCheck");
  let getPainScoreInput = watch("painScoreInput");

  let admissionId = props.displayInfo?.AdmissionId || props.admissionId;
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [referanceDoctor, setReferanceDoctor] = useState();
  const [referanceDoctorSearchString, setReferanceDoctorSearchString] =
    useState();
  //
  const [sliderReset, setSliderReset] = React.useState(null);
  const [mewsScore, setMewsScore] = React.useState();
  const [finalData, setFinalData] = React.useState();
  const [toDoArr, setToDoArr] = useState([]);
  //
  const [curentIvs, setCurentIvs] = React.useState([]);
  const [ongoingTretment, setOngoingTretment] = React.useState([]);
  const [pathgologyAwaitedTest, setPathologyAwaitedTest] = React.useState([]);
  const [pendingToDos, setPendingToDos] = React.useState([]);
  const [allPatchDetails, setAllPatchDetails] = React.useState(null);
  //
  const [openPost, setOpenPost] = React.useState(false);
  const [patchOrderSheetData, setPatchOrderSheetData] = useState(null);
  const [patchOrderSheetId, setPatchOrderSheetId] = useState(null);
  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };
  //View OrderSheet Modal
  const [openViewOrder, setViewOrderOpen] = React.useState(false);
  const handleViewOrderOpen = () => setViewOrderOpen(true);
  const handleViewOrderClose = () => setViewOrderOpen(false);

  console.log("sliderReset321", sliderReset, "mewsScore", mewsScore);

  const IsCPRInitiated = watch("cprYes");

  let finalMews;

  const [temp, pulse, rr] = watch(["temp", "pulse", "rr"]);

  const getReferanceDoctor = () => {
    referanceDoctorSearchString &&
      fetchDoctor(referanceDoctorSearchString).then((response) => {
        setReferanceDoctor(response.data.result);
      });
  };

  useEffect(() => {
    getReferanceDoctor();
  }, [referanceDoctorSearchString]);

  const avpuVal = watch("avpu");
  let bpStr = watch("bp");
  let arr = !!bpStr && bpStr?.split("/");
  let bp = arr && arr[0];
  const convertToCelsius = (fahrenheit) => {
    return ((fahrenheit - 32) * 5) / 9;
  };
  function SystolicBloodPressure(sbp) {
    if (sbp >= 200) {
      return 2;
    } else if (sbp >= 101 && sbp <= 199) {
      return 0;
    } else if (sbp >= 81 && sbp <= 100) {
      return 1;
    } else if (sbp >= 71 && sbp <= 80) {
      return 2;
    } else if (sbp <= 70) {
      return 3;
    }
    return 0; // Default return value
  }
  function PulseCalculation(pulse) {
    if (pulse <= 40) {
      return 2;
    } else if (pulse >= 41 && pulse <= 50) {
      return 1;
    } else if (pulse >= 51 && pulse <= 100) {
      return 0;
    } else if (pulse >= 101 && pulse <= 110) {
      return 1;
    } else if (pulse >= 111 && pulse <= 129) {
      return 2;
    } else if (pulse >= 130) {
      return 3;
    }
    return 0; // Default return value
  }
  function RespiratoryRate(bpm) {
    if (bpm <= 8) {
      return 2;
    } else if (bpm >= 9 && bpm <= 14) {
      return 0;
    } else if (bpm >= 15 && bpm <= 20) {
      return 1;
    } else if (bpm >= 21 && bpm <= 29) {
      return 2;
    } else if (bpm >= 30) {
      return 3;
    }
    return 0; // Default return value
  }
  function Temperature(tempCelsius) {
    if (tempCelsius < 35) return 2;
    else if (tempCelsius >= 35 && tempCelsius <= 38.4) return 0;
    else if (tempCelsius > 38.5) return 2;
    return 0;
  }

  const calculateMews = (bp, temp, pulse, rr, avpuVal) => {
    if (
      Number(bp) > 0 &&
      Number(temp) > 0 &&
      Number(pulse) > 0 &&
      Number(rr) > 0 &&
      avpuVal !== null
    ) {
      const bpValue = SystolicBloodPressure(bp);
      const pulseValue = PulseCalculation(pulse);
      const tempCelsius = convertToCelsius(temp);
      const tempValue = Temperature(tempCelsius);
      const rrValue = RespiratoryRate(rr);

      return bpValue + pulseValue + tempValue + rrValue + Number(avpuVal);
    }
    return 0; // Default return value if inputs are invalid
  };

  //useEffect to set the displayof mews score
  useEffect(() => {
    const finalMews = calculateMews(bp, temp, pulse, rr, avpuVal);
    setMewsScore(finalMews);

    // if (mewsDivElement.current) {
    //   if (finalMews >= 5) {
    //     mewsDivElement.current.innerHTML = `
    //       <div class="flex items-center">
    //         <p class="text-gray-700 px-2 font-bold">MEWS</p>
    //         <div class="w-10 h-10 rounded-full border-2 border-customRed flex justify-center bg-customRed items-center text-white">
    //           <p class="text-white py-2">${finalMews}</p>
    //         </div>
    //         <p class="px-2 font-bold text-customRed">Please Call Doctor For Consultation</p>
    //       </div>
    //     `;
    //   } else if (finalMews < 5) {
    //     mewsDivElement.current.innerHTML = `
    //       <div class="flex items-center">
    //         <p class="text-gray-700 px-2 font-bold">MEWS</p>
    //         <div class="w-10 h-10 rounded-full border-2 border-green-500 flex justify-center bg-green-500 items-center">
    //           <p class="text-white py-2">${finalMews}</p>
    //         </div>
    //         <p class="px-2 font-bold text-green-500">No Need to Call Doctor For Consultation</p>
    //       </div>
    //     `;
    //   }
    // }
  }, [bp, temp, pulse, rr, props.open, avpuVal]);

  useEffect(() => {
    if (props.selectedRow !== null && props.selectedRow !== undefined) {
      // const postObj = {
      //   admissionId: props.admissionId,
      //   fromDate: format(new Date(props.fromDate), "yyyy-MM-dd"),
      //   toDate: format(new Date(props.toDate), "yyyy-MM-dd"),
      //   fromTime: format(new Date(props.fromTime), "HH:mm:ss"),
      //   toTime: format(new Date(props.toTime), "HH:mm:ss"),
      //   id: props?.selectedRow?.ID,
      // };
      // NursesNotePrint(postObj)
      //   .then((response) => response.data)
      //   .then((res) => {
      //     setPatchOrderSheetData(res.result);
      //   });
      handleOrderSheetDataDetails(props?.selectedRow?.ordersheetId);
    }
  }, [props.selectedRow]);

  console.log("props?.selectedRow", props?.selectedRow);

  const handleOrderSheetDataDetails = (orderSheetId) => {
    getNursingNoteDescription(orderSheetId).then((response) => {
      setPatchOrderSheetData(response?.data?.result);
      setPatchOrderSheetId(orderSheetId);
    });
  };

  useEffect(() => {
    if (patchOrderSheetData !== null) {
      setMewsScore(Number(patchOrderSheetData?.mews));
      setValue("temp", patchOrderSheetData?.temp || "");
      setValue("subjective", patchOrderSheetData?.Subjective || "");
      setValue("bp", patchOrderSheetData?.bp || "");
      setValue("pulse", patchOrderSheetData.pulse || "");
      setValue("rr", patchOrderSheetData?.rr || "");
      setValue("spO2", patchOrderSheetData?.SPO2 || "");
      setValue("peripheralpulse", patchOrderSheetData?.peripheralPulse || "");
      setValue("cvp", patchOrderSheetData?.cvp || "");
      setSliderReset(patchOrderSheetData?.painScore);
      setValue("painScoreInput", patchOrderSheetData?.painScore);
      setValue(
        "referanceDoctor",
        JSON.parse(patchOrderSheetData?.referralDoctors)?.length > 0
          ? JSON.parse(patchOrderSheetData?.referralDoctors).map((val) => ({
              id: val.referralDoctorId,
              label: val.referralDoctorName,
              value: val.referralDoctorId,
            }))
          : null,
      );
      setValue("cvs", patchOrderSheetData?.CVS || "");
      setValue("rs", patchOrderSheetData?.RS || "");
      setValue("pa", patchOrderSheetData?.PA || "");
      setValue("cns", patchOrderSheetData?.cns || "");
      setValue("pv", patchOrderSheetData?.PV || "");
      setValue("localexamation", patchOrderSheetData?.LocalExamination || "");
      setValue("other", patchOrderSheetData?.Other || "");
      setValue("assessment", patchOrderSheetData?.Assesment || "");
      setValue("plan", patchOrderSheetData?.plan || "");
      setValue("cprNotes", patchOrderSheetData?.cprNotes || "");
      if (patchOrderSheetData.iscpr !== null) {
        setValue(
          "cprYes",
          patchOrderSheetData.iscpr === true
            ? patchOrderSheetData.iscpr
            : false,
        );
        setValue(
          "cprNo",
          patchOrderSheetData.iscpr === false
            ? patchOrderSheetData.iscpr
            : false,
        );
      }
      setValue(
        "cprStartTime",
        patchOrderSheetData?.cprStartTime
          ? parse(
              patchOrderSheetData.cprStartTime,
              "yyyy-MM-dd HH:mm:ss.SSS",
              new Date(),
            )
          : null,
      );
      setValue(
        "cprEndTime",
        patchOrderSheetData?.cprEndTime
          ? parse(
              patchOrderSheetData.cprEndTime,
              "yyyy-MM-dd HH:mm:ss.SSS",
              new Date(),
            )
          : null,
      );
      setValue("cycleOfCprGiven", patchOrderSheetData?.cprCycle || "");
      if (patchOrderSheetData !== null) {
        setValue("rocsYes", patchOrderSheetData.rosc === true ? true : false);
        setValue("roscNo", patchOrderSheetData.rosc === false ? true : false);
      }
      if (patchOrderSheetData.DietPlan === "") {
        setValue("dietPlanCheck", false);
      }
      setValue("dietPlan", patchOrderSheetData?.DietPlan || "");
      setToDoArr(
        patchOrderSheetData.ToDoList !== null
          ? patchOrderSheetData.ToDoList
          : [],
      );
      // setMewsScore(patchOrderSheetData?.mews);
    }
  }, [patchOrderSheetData]);

  console.log("patchOrderSheetData", patchOrderSheetData);
  console.log("mewsScore", mewsScore);

  function postOrderSheet(obj) {
    addNewOrderSheet(obj)
      .then((response) => {
        if (response.data.statusCode === 200) {
          successAlert(response.data.message);
          setOpenBackdrop(false);
          props.setOpen(false);
          setPatchOrderSheetId(null);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  }

  function addRecord() {
    setOpenPost(false);
    setOpenBackdrop(true);
    postOrderSheet(finalData);
  }

  const onSubmitDataHandler = (data) => {
    let getUserId = JSON.parse(localStorage.getItem("userInfo"));
    let messageObj = {
      subjective: data.subjective,
      bp: data.bp,
      cns: data.cns,
      cvp: data.cvp,
      cvs: data.cvs,
      other: data.other,
      pa: data.pa,
      pain: data.pain,
      cprNotes: data.cprNotes,
      peripheral: data.peripheralpulse,
      pulse: data.pulse,
      pv: data.pv,
      rr: data.rr,
      rs: data.rs,
      spo2: data.spO2,
      other: data.other,
      localExamination: data.localexamation,
      assessment: data.assessment,
      dietPlan: data.dietPlan,
    };

    const messageString = Object.entries(messageObj)
      .filter(
        ([key, value]) => typeof value === "string" && value.trim() !== "",
      )
      .map(([key, value]) => ` ${key}:${value}`)
      .join("\n");

    let cprCheck;
    if (data.cprYes === true && data.cprNo === false) {
      cprCheck = true;
    } else if (data.cprYes === false && data.cprNo === true) {
      cprCheck = false;
    } else if (data.cprYes === false && data.cprNo === false) {
      cprCheck = null;
    }

    let isRocs;
    if (data.rocsYes === true && data.roscNo === false) {
      isRocs = true;
    } else if (data.rocsYes === false && data.roscNo === true) {
      isRocs = false;
    } else if (data.rocsYes === false && data.roscNo === false) {
      isRocs = null;
    }

    let stoolCheck;
    let urineCheck;
    if (data.stoolYes === true && data.stoolNo === false) {
      stoolCheck = "Yes";
    } else if (data.stoolYes === false && data.stoolNo === true) {
      stoolCheck = "No";
    }
    if (data.urineYes === true && data.urineNo === false) {
      urineCheck = "Yes";
    } else if (data.urineYes === false && data.urineNo === true) {
      urineCheck = "No";
    }
    let ordersheetPostObj = {
      menuId: props.menuId,
      privilege: props.privilege,
      // referenceDoctorId: {id: data.referanceDoctor?.id},
      referenceDoctorId: data.referanceDoctor?.map((item) => item.id),
      admissionId:
        admissionId ||
        (props?.displayInfo?.AdmissionId > 0
          ? props?.displayInfo?.AdmissionId
          : props?.displayInfo?.EmergencyPatientId),
      addedBy: getUserId.userId,
      assessment: data.assessment,
      bp: data.bp,
      cns: data.cns,
      cvp: data.cvp,
      cvs: data.cvs,
      patientId: props.isFromEmergency
        ? props.patientId
        : props.displayInfo?.PatientId || props?.admissionPatientId,

      // "givenDate": "2023-04-14T10:41:30.215Z",
      // "givenTime": "2023-04-14T10:41:30.215Z",
      isCancel: false,
      localExamination: data.localexamation,
      mews: mewsScore,
      opdIpd:
        props?.displayInfo?.AdmissionId > 0
          ? 1
          : props?.displayInfo?.EmergencyPatientId
            ? 2
            : 1,
      other: data.other,
      pa: data.pa,
      pain: data.plan,
      painScore: sliderReset !== null ? sliderReset : getPainScoreInput,
      cprNotes: data.cprNotes,
      dietPlan: data.dietPlan,
      peripheral: data.peripheralpulse,
      pulse: data.pulse,
      pv: data.pv,
      // remark:
      rr: data.rr,
      rs: data.rs,
      spo2: data.spO2,
      subjective: data.subjective,
      message: messageString,
      isCpr: cprCheck,
      cprStartTime: data.cprStartTime
        ? format(new Date(data.cprStartTime), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
        : null,
      cprEndTime: data?.cprEndTime
        ? format(new Date(data.cprEndTime), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
        : null,
      cprCycles: data.cycleOfCprGiven ? data.cycleOfCprGiven : null,
      rosc: isRocs,

      // message: `
      // subjective:${data.subjective}\n
      // bp:${data.bp}\n
      // cns:${data.cns}\n
      // cvp:${data.cvp}\n
      // cvs:${data.cvs}\n
      // other:${data.other}\n
      // pa:${data.pa}\n
      // pain:${data.pain}\n
      // cprNotes:${data.cprNotes}\n
      // peripheral:${data.peripheralpulse}\n
      // pulse:${data.pulse}\n
      // pv:${data.pv}\n
      // rr:${data.rr}\n
      // rs:${data.rs}\n
      // spo2:${data.spO2}\n
      // other:${data.other}\n
      // localExamination:${data.localexamation}\n
      // assessment:${data.assessment}
      // dietPlan:${data.dietPlan}
      // `,
      temp: data.temp,
      // crt: data.crt,
      // "updatedDate": "2023-04-14T10:41:30.215Z",
      // "updatedTime": "2023-04-14T10:41:30.215Z"

      orderSheetToDoList:
        toDoArr?.map((item) => ({
          groupId: item?.groupId,
          isRepeat: item?.["Is Repeat"],
          isUrgent: item?.["Is Urgent"],
          scheduledDate: item?.["Scheduled Date"],
          // ? format(item?.["Scheduled Date"], "yyyy-MM-dd")
          // : null,
          scheduledTime: item?.["Scheduled Time"],
          // ? format(item?.["Scheduled Time"], "HH:mm:ss.000")
          // : null,
          taskDescription: item?.Task,
          taskServiceId: item?.taskId,
          todoId: null,
        })) || [],
      id: patchOrderSheetId !== null ? patchOrderSheetId : null,
    };

    // else if (
    //   (!data.stoolYes && !data.stoolNo) ||
    //   (!data.urineYes && !data.urineNo)
    // ) {
    //   warningAlert("Please select Yes/No for Stool/Urine");
    // }
    if (data.avpu === "" || data.avpu === undefined || data.avpu === null) {
      warningAlert("Please select AVPU Value");
    } else if (
      data.avpu !== "" &&
      data.avpu !== undefined &&
      data.avpu !== null
    ) {
      setOpenPost(true);
      setFinalData(ordersheetPostObj);
    }
    console.log("ordersheetPostObj", ordersheetPostObj);
  };

  const handleTaskSheets = () => {
    fetchOrderSheetTaskDetails(admissionId)
      .then((response) => response.data)
      .then((res) => {
        setOngoingTretment(res.result?.onGoingDrugs || []);
        setPendingToDos(res.result?.todolist || []);
        setCurentIvs(res.result?.iv || []);
        setPathologyAwaitedTest(res.result?.pathologyAwaitedTest || []);
        setAllPatchDetails(res.result);
      });
  };

  useEffect(() => {
    handleTaskSheets();
  }, []);

  const handlleOnkeyDownInput = (e) => {
    if (
      e?.key === "-" ||
      e?.key === "+" ||
      e?.code === "ArrowUp" ||
      e?.code === "ArrowDown" 
      // e?.code === "NumpadDecimal"
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      {/* Model open on add button  start */}
      <div className="w-full grid justify-center items-center rounded lg:px-0 mt-2">
        <Modal
          open={props.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={Style} className="max-h-[92%] w-[80%] p-2   ">
            <CancelPresentationIconButton
              onClick={() => {
                props.handleClose();
                reset(defaultValues);
                setPatchOrderSheetId(null);
              }}
            />
            <div className="">
              <h1 className="text-lg font-semibold  text-gray-700">
                Order Sheet
              </h1>

              <div className="grid grid-cols-7 gap-3 ">
                <div className="col-span-4 gap-3">
                  <div className="">
                    {!props.isFromEmergency && (
                      <div className="grid grid-cols-3 lg:grid-cols-4 gap-x-2 items-center">
                        <div className="bg-gray-100 px-2  rounded-md  border border-gray-300 mt-2 w-full col-span-2 lg:col-span-3">
                          <div className="grid xl:grid-cols-2 text-black text-sm xl:text-xs 2xl:text-sm items-center w-full gap-y-1">
                            <div className="flex space-x-1 items-center">
                              <label className="font-semibold w-[88px]">
                                Patient Name
                              </label>
                              <label>
                                &nbsp;:&nbsp;
                                {props.displayInfo?.PatientName ||
                                  props.selectedPatient?.PatientName}
                              </label>
                            </div>
                            <div className="flex space-x-1 items-center">
                              <label className="font-semibold w-[88px]">
                                MR No.
                              </label>
                              <label>
                                &nbsp;:&nbsp;
                                {props.displayInfo?.MRNo ||
                                  props.selectedPatient?.MRNo}
                              </label>
                            </div>
                            <div className="flex space-x-1 items-center">
                              <label className="font-semibold w-[88px]">
                                Age
                              </label>
                              <label>
                                &nbsp;:&nbsp;
                                {props.displayInfo?.AgeYear ||
                                  props.selectedPatient?.AgeYear}
                              </label>
                            </div>
                            <div className="flex space-x-1 items-center">
                              <label className="font-semibold w-[88px]">
                                Department
                              </label>
                              <label>
                                &nbsp;:&nbsp;
                                {props.displayInfo?.Department ||
                                  props.selectedPatient?.Department}
                              </label>
                            </div>
                            <div className="flex space-x-1 items-center">
                              <label className="font-semibold w-[88px]">
                                Doctor Name
                              </label>
                              <label>
                                &nbsp;:&nbsp;
                                {props.displayInfo?.DoctorName ||
                                  props.selectedPatient?.DoctorName}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="flex space-x-2 justify-end w-full">
                          <CommonButton
                            type="button"
                            className="border border-customRed text-customRed"
                            label="Reset"
                            onClick={() => {
                              reset(defaultValues);
                              setPatchOrderSheetId(null);
                            }}
                          />
                          <CommonButton
                            type="button"
                            className="bg-customBlue text-white"
                            label="View"
                            onClick={() => {
                              handleViewOrderOpen();
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!props.isFromEmergency && (
                      <div className="grid grid-cols-2 mt-2  gap-1">
                        <div className="bg-[#CFE8FF] px-2  rounded-md  border border-gray-300">
                          <div className=" text-black  text-sm items-center w-full gap-1 py-1">
                            <div className="flex gap-2 w-full font-semibold text-sm">
                              <span className="w-16 font-semibold">
                                Diagnosis
                              </span>
                              <div className="flex space-x-2">
                                <span>:</span>
                                <span className="font-normal">
                                  {props.displayInfo?.Diagnosis ||
                                    props.selectedPatient?.Diagnosis}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-[#FFECE3] px-2  rounded-md  border border-gray-300 ">
                          <div className=" text-black  text-sm items-center w-full gap-1 py-1">
                            <div className="flex   gap-2 w-full font-semibold text-sm">
                              <span className="w-16 font-semibold">
                                Allergies
                              </span>
                              <div className="flex space-x-2 ">
                                <span>:</span>
                                <span className="font-normal">
                                  {/* {props.displayInfo?.Allergies ||
                                    props.selectedPatient?.Allergies} */}
                                  {props.selectedPatient
                                    ?.AllergiesFromDischarge === null
                                    ? props.selectedPatient?.Allergies
                                    : props.selectedPatient
                                        ?.AllergiesFromDischarge}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                  //className="h-[735px] overflow-y-auto"
                  >
                    <form
                      // onSubmit={handleSubmit(onSubmitDataHandler)}
                      className="grid grid-cols-1 md:grid-cols-1 px-2"
                    >
                      <>
                        <div className="pt-2">
                          <InputArea
                            control={control}
                            className="bg-white"
                            id="outlined-multiline-static"
                            name="subjective"
                            {...register("subjective")}
                            label="Subjective"
                            InputLabelProps={{ shrink: true }}
                            multiline
                            rows={3}
                            fullWidth
                          />
                        </div>

                        <h1 className="font-semibold text-sm text-gray-700 py-1 pt-2">
                          Objective
                        </h1>
                        <div className="row">
                          <div className="grid py-3">
                            <div className="grid grid-cols-7 w-full gap-3">
                              {/* <legend className="font-semibold text-sm whitespace-nowrap grid items-center text-gray-700">
                            Vitals :
                          </legend> */}
                              <InputField
                                name="temp"
                                type="number"
                                className="appearance-none"
                                variant="outlined"
                                label="Temp"
                                error={errors.temp}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />
                              <InputField
                                name="pulse"
                                type="number"
                                variant="outlined"
                                label="Pulse "
                                error={errors.pulse}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />
                              <InputField
                                name="rr"
                                type="number"
                                variant="outlined"
                                label="Respiration Rate (RR)"
                                error={errors.rr}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />
                              <InputField
                                name="bp"
                                // type="number"
                                variant="outlined"
                                label="BP "
                                error={errors.bp}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />

                              <InputField
                                name="spO2"
                                // type="number"
                                variant="outlined"
                                label="spO2 "
                                error={errors.spO2}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />

                              <InputField
                                name="peripheralpulse"
                                // type="number"
                                variant="outlined"
                                label="Peripheral Pulse "
                                error={errors.peripheralpulse}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />

                              <InputField
                                name="cvp"
                                variant="outlined"
                                // type="number"
                                label="CVP "
                                error={errors.cvp}
                                control={control}
                                onKeyDown={(e) => handlleOnkeyDownInput(e)}
                              />

                              <div className="col-span-5 pl-2 py-2">
                                <RadioField
                                  label=""
                                  name="avpu"
                                  control={control}
                                  dataArray={avpuArray}
                                />
                              </div>

                              {mewsScore > 0 &&
                                (mewsScore && mewsScore <= 5 ? (
                                  <div className="flex items-center col-span-3 text-sm ">
                                    <p className=" text-gray-700 px-2 font-bold">
                                      MEWS
                                    </p>
                                    <div className="w-8 h-8 rounded-full border-2 border-green-500 flex justify-center  bg-green-500 items-center text-white">
                                      <p className=" text-white text-sm ">
                                        {mewsScore}
                                      </p>
                                    </div>
                                    <p class="px-2 font-bold text-green-500">
                                      No Need To Call Doctor For Consultation
                                    </p>
                                  </div>
                                ) : (
                                  <div className="flex items-center col-span-2 text-sm">
                                    <p className=" text-gray-700 px-2 font-bold">
                                      MEWS
                                    </p>
                                    <div className="w-8 h-8 rounded-full border-2 border-red-500 flex justify-center  bg-red-500 items-center text-white">
                                      <p className=" text-white text-sm ">
                                        {mewsScore}
                                      </p>
                                    </div>
                                    <p class="px-2 font-bold text-red-500">
                                      Please Call Doctor For Consultation
                                    </p>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-6 gap-2">
                          <div className="col-span-4 bg-white shadow-md rounded-lg overflow-hidden">
                            <div className="font-semibold text-sm text-gray-700 py-1 pt-2 bg-[#DFE3FF] px-2 rounded-t-lg">
                              Pain Score
                            </div>
                            <div className="flex space-x-2 p-2">
                              <div className="w-full flex flex-col items-center">
                                <div className="w-full">
                                  <img
                                    className="w-full h-auto rounded-lg object-contain"
                                    src={PainAssessmentScale}
                                    alt="Pain Assessment Scale"
                                  />
                                </div>
                                <div className="w-full mt-2 ml-32 xl:ml-44 2xl:ml-52">
                                  <div className="w-[83%] xl:w-[78%] 2xl:w-[78%] ">
                                    <CustomSlider
                                      className="painScore"
                                      control={control}
                                      {...register("painScore")}
                                      name="painScore"
                                      onChange={(event, value) => {
                                        setSliderReset(value);
                                        setValue("painScoreInput", value);
                                      }}
                                      aria-label="Custom marks"
                                      value={
                                        sliderReset !== null ? sliderReset : 0
                                      }
                                      getAriaValueText={valueText}
                                      min={0}
                                      step={1}
                                      max={10}
                                      valueLabelDisplay="auto"
                                      aria-labelledby="non-linear-slider"
                                      style={{ height: "14px" }}
                                      marks={sliderMarks}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-span-2">
                            <div>
                              <InputField
                                control={control}
                                name="painScoreInput"
                                label="Pain Score"
                                disabled={sliderReset !== null}
                                error={errors.painScoreInput}
                              />
                            </div>
                            {AllowInfo && (
                              <div className="col-span-2 grid gap-3">
                                <div className="">
                                  <CheckBoxField
                                    control={control}
                                    name="referanceDoctorCheck"
                                    label="No Doctor"
                                  />
                                </div>
                                {!noReferDoct && (
                                  <div className="">
                                    <SearchDropdown
                                      control={control}
                                      name="referanceDoctor"
                                      label="Other Refer Doctor"
                                      dataArray={referanceDoctor}
                                      isMulti={true}
                                      handleInputChange={(e) => {
                                        setReferanceDoctorSearchString(e);
                                      }}
                                      searchIcon={true}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder="Other Refer Doctor"
                                      error={errors.referanceDoctor}
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {!props.isFromEmergency && AllowInfo && (
                          <legend className="font-semibold text-sm text-gray-700 py-2 pt-2">
                            Systemic Examination :
                          </legend>
                        )}

                        <div className="grid grid-cols-1 gap-y-2 gap-x-2 ">
                          {/*!props.isFromEmergency && AllowInfo && (*/}
                          <fieldset
                            disabled={
                              !props.isFromEmergency && AllowInfo ? false : true
                            }
                            onClick={() =>
                              !AllowInfo &&
                              warningAlert("Allowed to view only.")
                            }
                          >
                            <div className="grid grid-cols-4 gap-3 pb-3">
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="cvs"
                                {...register("cvs")}
                                label="CVS"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                                disabled={AllowInfo ? false : true}
                              />

                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="rs"
                                {...register("rs")}
                                label="RS"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                                disabled={AllowInfo ? false : true}
                              />
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="pa"
                                {...register("pa")}
                                label="P/A"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                                disabled={AllowInfo ? false : true}
                              />

                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="cns"
                                {...register("cns")}
                                label="CNS"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                                disabled={AllowInfo ? false : true}
                              />
                              <div className="col-span-2">
                                <InputArea
                                  control={control}
                                  className="bg-white"
                                  id="outlined-multiline-static"
                                  name="pv"
                                  {...register("pv")}
                                  label="P/V"
                                  InputLabelProps={{ shrink: true }}
                                  multiline
                                  rows={3}
                                  fullWidth
                                  disabled={AllowInfo ? false : true}
                                />
                              </div>
                              <div className="col-span-2">
                                <InputArea
                                  control={control}
                                  className="bg-white"
                                  id="outlined-multiline-static"
                                  name="localexamation"
                                  {...register("localexamation")}
                                  label="Local Examination"
                                  InputLabelProps={{ shrink: true }}
                                  multiline
                                  rows={3}
                                  fullWidth
                                  disabled={AllowInfo ? false : true}
                                />
                              </div>
                            </div>
                          </fieldset>

                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="other"
                                {...register("other")}
                                label="Other"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                              />
                            </div>
                            <div className="w-full ">
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="assessment"
                                {...register("assessment")}
                                label="Assessment"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                              />
                            </div>
                            <div className="w-full ">
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="plan"
                                {...register("plan")}
                                label="Plan"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                              />
                            </div>

                            <div className="w-full">
                              <InputArea
                                control={control}
                                className="bg-white"
                                id="outlined-multiline-static"
                                name="cprNotes"
                                {...register("cprNotes")}
                                label="CPR Notes"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={3}
                                fullWidth
                                disabled={!watch("cprYes")}
                              />
                            </div>

                            <div className="flex">
                              <p className="my-2 mr-2  tracking-wide text-sm font-Poppins">
                                CPR Initiated:
                              </p>
                              {/* <RadioField
                                label=""
                                name="isCprInitiated"
                                control={control}
                                dataArray={isCPR}
                              /> */}

                              <fieldset
                                onChange={(e) => {
                                  if (e.target.checked === true) {
                                    setValue("cprNo", false);
                                  } else {
                                    setValue("cprStartTime", null);
                                    setValue("cprEndTime", null);
                                    setValue("cycleOfCprGiven", "");
                                    setValue("rocsYes", false);
                                    setValue("roscNo", false);
                                  }
                                }}
                              >
                                <CheckBoxField
                                  label={"Yes"}
                                  name={"cprYes"}
                                  control={control}
                                />
                              </fieldset>

                              <fieldset
                                onChange={(e) => {
                                  if (e.target.checked === true) {
                                    setValue("cprYes", false);
                                    setValue("cprStartTime", null);
                                    setValue("cprEndTime", null);
                                    setValue("cycleOfCprGiven", "");
                                    setValue("rocsYes", false);
                                    setValue("roscNo", false);
                                  }
                                }}
                              >
                                <CheckBoxField
                                  label={"No"}
                                  name={"cprNo"}
                                  control={control}
                                />
                              </fieldset>
                            </div>

                            {IsCPRInitiated && (
                              <div className="col-span-2 grid grid-cols-4 xl:grid-cols-5 gap-2 items-center">
                                <div className="flex col-span-2 xl:col-span-1 items-center">
                                  {/* <p className="w-full font-semibold text-sm">
                                    CPR Started Time :
                                  </p> */}
                                  <TimePickerFieldNew
                                    control={control}
                                    name="cprStartTime"
                                    inputFormat="hh:mm"
                                    label={"CPR Started Time"}
                                  />
                                </div>
                                <div className="flex col-span-2 xl:col-span-1 items-center">
                                  {/* <p className="w-full font-semibold text-sm">
                                    CPR End Time :
                                  </p> */}
                                  <TimePickerFieldNew
                                    control={control}
                                    name="cprEndTime"
                                    inputFormat="hh:mm"
                                    label={"CPR End Time"}
                                  />
                                </div>

                                <div className="col-span-2 xl:col-span-1">
                                  <InputField
                                    name="cycleOfCprGiven"
                                    label="Cycle of CPR Given"
                                    variant="outlined"
                                    // error={errors.representativeAddress}
                                    control={control}
                                    disabled={false}
                                    type={"number"}
                                  />
                                </div>

                                <div className="flex  col-span-2">
                                  <p className="mr-3 mt-[8px] tracking-wide text-sm font-Poppins">
                                    Rosc Achieved :
                                  </p>
                                  {/* <RadioField
                                    label=""
                                    name="isRocsAchieved"
                                    control={control}
                                    dataArray={isRocs}
                                  /> */}

                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("roscNo", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      label={"Yes"}
                                      name={"rocsYes"}
                                    />
                                  </fieldset>

                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("rocsYes", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      label={"No"}
                                      name={"roscNo"}
                                    />
                                  </fieldset>
                                </div>
                              </div>
                            )}
                            {/*AllowInfo && (*/}

                            <div
                              className="w-full grid grid-cols-6 gap-2 col-span-2"
                              onClick={() =>
                                !AllowInfo &&
                                warningAlert("Allowed to view only.")
                              }
                            >
                              {AllowInfo && (
                                <div className="col-span-1">
                                  <CheckBoxField
                                    control={control}
                                    name="dietPlanCheck"
                                    label="No Diet Plan"
                                  />
                                </div>
                              )}
                              {!noDietPlan && (
                                <div className="col-span-3">
                                  <InputArea
                                    control={control}
                                    className="bg-white"
                                    id="outlined-multiline-static"
                                    name="dietPlan"
                                    {...register("dietPlan")}
                                    label="Diet Plan"
                                    InputLabelProps={{ shrink: true }}
                                    multiline
                                    rows={3}
                                    fullWidth
                                    error={errors.dietPlan}
                                    disabled={AllowInfo ? false : true}
                                  />
                                </div>
                              )}
                              <div className="hidden">
                                <label className="font-semibold">Stool</label>
                                <div className="flex items-center space-x-2 -mt-2">
                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("stoolNo", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      name="stoolYes"
                                      label="Yes"
                                    />
                                  </fieldset>
                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("stoolYes", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      name="stoolNo"
                                      label="No"
                                    />
                                  </fieldset>
                                </div>
                              </div>
                              <div className="hidden">
                                <label className="font-semibold">Urine</label>
                                <div className="flex items-center space-x-2 -mt-2">
                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("urineNo", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      name="urineYes"
                                      label="Yes"
                                    />
                                  </fieldset>
                                  <fieldset
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setValue("urineYes", false);
                                      }
                                    }}
                                  >
                                    <CheckBoxField
                                      control={control}
                                      name="urineNo"
                                      label="No"
                                    />
                                  </fieldset>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {AllowInfo && (
                          <div className="mt-3">
                            <ToDoListComponent
                              toDoArr={toDoArr}
                              setToDoArr={setToDoArr}
                            />
                          </div>
                        )}
                      </>
                      {getUserRole === "Admin" ? (
                        ""
                      ) : (
                        <div className="flex gap-2 justify-end pt-2">
                          {props.displayInfo !== null ||
                          props.admissionId !== undefined ? (
                            <>
                              <CommonButton
                                type="button"
                                className="bg-customGreen text-white"
                                label={
                                  patchOrderSheetId !== null ? "Update" : "Save"
                                }
                                onClick={handleSubmit(onSubmitDataHandler)}
                              />
                            </>
                          ) : null}
                        </div>
                      )}
                    </form>
                  </div>
                </div>
                <div className="col-span-3 ">
                  <OtherDetails
                    pendingToDos={pendingToDos}
                    ongoingTretment={ongoingTretment}
                    curentIvs={curentIvs}
                    pathgologyAwaitedTest={pathgologyAwaitedTest}
                    allPatchDetails={allPatchDetails}
                    handleTaskSheets={handleTaskSheets}
                    AllowInfo={AllowInfo}
                  />
                </div>
              </div>

              <CommonBackDrop openBackdrop={openBackdrop} />
            </div>
          </Box>
        </Modal>
        <ConfirmationModal
          confirmationOpen={openPost}
          confirmationHandleClose={handleClosePost}
          confirmationSubmitFunc={addRecord}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure want to add this record ?"
          confirmationButtonMsg="Add"
        />

        {openViewOrder && (
          <ViewOrderSheet
            openViewOrder={openViewOrder}
            handleViewOrderClose={handleViewOrderClose}
            admissionId={admissionId}
            ptInfo={props.displayInfo || props.selectedPatient}
            handleOrderSheetDataDetails={handleOrderSheetDataDetails}
          />
        )}
      </div>
    </>
  );
}

// {
//     "Subjective": "Subjective",
//     "temp": "2",
//     "bp": "2",
//     "pulse": "2",
//     "rr": "2",
//     "cvp": "2",
//     "mews": "9",
//     "cns": "2",
//     "SPO2": "2",
//     "CVS": "2",
//     "RS": "2",
//     "PA": "2",
//     "PV": "2",
//     "LocalExamination": "2",
//     "Other": "2",
//     "Assesment": "2",
//     "pain": "2",
//     "DietPlan": "Dieat Plan",
//     "SpecialNote": "",
//     "consultantNote": null
// }
